export const LINK_LIMITS = { perScene: 100, label: 60 };
export const LINK_KINDS = ['link.set', 'link.remove'];
export const isLinkBody = (b) => LINK_KINDS.includes(b.kind);
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const isUuid = (v) => typeof v === 'string' && UUID_RE.test(v);
const isObj = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);
const LINE_BAD = /[\u0000-\u001f\u007f]/;
const isCoord = (v) => typeof v === 'number' && Number.isFinite(v) && Math.abs(v) <= 1_000_000;
/** A link from the wire or the log; a missing `shown` is hidden. */
export function parseLink(v) {
    if (!isObj(v) || !isUuid(v.id) || !isUuid(v.toScene) || !isObj(v.at) || !isCoord(v.at.x) || !isCoord(v.at.y))
        return null;
    const label = v.label;
    if (typeof label !== 'string' || !label.trim() || label.length > LINK_LIMITS.label || LINE_BAD.test(label))
        return null;
    if (v.shown !== undefined && typeof v.shown !== 'boolean')
        return null;
    return { id: v.id, at: { x: v.at.x, y: v.at.y }, label: label.trim(), toScene: v.toScene, shown: v.shown === true };
}
export function parseLinkBody(b) {
    switch (b.kind) {
        case 'link.set': {
            const link = parseLink(b.link);
            return link ? { kind: 'link.set', link } : null;
        }
        case 'link.remove': return isUuid(b.id) ? { kind: 'link.remove', id: b.id } : null;
        default: return null;
    }
}
export function normaliseLinks(v) {
    const out = {};
    if (!isObj(v))
        return out;
    for (const l of Object.values(v)) {
        const link = parseLink(l);
        if (link)
            out[link.id] = link;
    }
    return out;
}
const copyLink = (l) => ({ ...l, at: { ...l.at } });
export function reduceLinks(links, body) {
    if (body.kind === 'link.set')
        return { ...links, [body.link.id]: copyLink(body.link) };
    if (!links[body.id])
        return links;
    const { [body.id]: _gone, ...rest } = links;
    return rest;
}
/** Why the DM's link is refused, or null: at most `perScene` on a map, never to the scene it is on, never to a scene the table lacks. */
export function linkRefusal(links, body, here, scenes) {
    if (body.kind === 'link.remove')
        return links[body.id] ? null : 'That link is gone.';
    if (!links[body.link.id] && Object.keys(links).length >= LINK_LIMITS.perScene)
        return `A map holds at most ${LINK_LIMITS.perScene} scene links. Remove one first.`;
    if (here !== null && body.link.toScene === here)
        return 'A link leads to another scene, not to this one.';
    if (scenes && !scenes.includes(body.link.toScene))
        return 'That scene is gone.';
    return null;
}
/** The links a player sees (issue 1173): the shown ones of the scene they are on, each a marker and its label alone. */
export function playerLinks(links) {
    return Object.values(links ?? {}).filter((l) => l.shown).map((l) => ({ id: l.id, at: { x: l.at.x, y: l.at.y }, label: l.label }));
}
/** The DM's links whole, copied. */
export const copyLinks = (links) => Object.fromEntries(Object.values(links ?? {}).map((l) => [l.id, copyLink(l)]));
//# sourceMappingURL=links.js.map